import { useEffect } from 'react'

import { Link, useLocation } from 'react-router-dom'

import Navbar from '@/Navigation/Navbar'

import Image from '@Pure/Image'

export default function FrontHeader ({ ...props })
{
	const location = useLocation();

	useEffect(function ()
	{
		document.scrollingElement.scrollTop = 0; // reset scroll au changement de page
	},
	[location.pathname]);

	return (
		<header className="c-front-header">

			<Link to="/" className="c-front-header__logo">

				<Image src="/images/logo/logo-osaba-blanc.svg"
					alt="Osaba logo blanc"
					className="c-front-header__logo-svg"
				/>

				<div className="c-front-header__logo-title">

					<span className="c-front-header__logo-main-title">
						OSABA
					</span>

					<span>
						COMPAGNON DE VOS
					</span>

					<span>
						PROJETS IMMOBILIERS
					</span>

				</div>

			</Link>

			<Navbar />

		</header>
	);
}